import { useQueryClient } from "@tanstack/react-query";
import {
  useV1ProductionRoutingOperationDependenciesList,
  useV1ProductionRoutingOperationDependenciesCreate,
  useV1ProductionRoutingOperationDependenciesDestroy,
  useV1ProductionRoutingOperationsJoinTypePartialUpdate,
  getV1ProductionRoutingOperationDependenciesListQueryKey,
  getV1ProductionRoutingOperationsListQueryKey,
} from "../../api/generated/v1/v1";
import { CreateDependencyEdgeInput } from "./am030-types";

export function useRoutingOperationDependencies(routingRevisionId: string) {
  return useV1ProductionRoutingOperationDependenciesList(
    { routing_revision: routingRevisionId } as any,
    { query: { enabled: Boolean(routingRevisionId) } }
  );
}

export function useCreateRoutingOperationDependency() {
  const queryClient = useQueryClient();
  const mutation = useV1ProductionRoutingOperationDependenciesCreate({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getV1ProductionRoutingOperationDependenciesListQueryKey(),
        });
      },
    },
  });

  return {
    ...mutation,
    mutateAsync: async (input: CreateDependencyEdgeInput) => {
      return mutation.mutateAsync({
        data: {
          routing_revision: input.routingRevision,
          upstream_operation: input.upstreamOperation,
          downstream_operation: input.downstreamOperation,
        } as any,
      });
    },
  };
}

export function useDeleteRoutingOperationDependency(_routingRevisionId: string) {
  const queryClient = useQueryClient();
  const mutation = useV1ProductionRoutingOperationDependenciesDestroy({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getV1ProductionRoutingOperationDependenciesListQueryKey(),
        });
      },
    },
  });

  return {
    ...mutation,
    mutateAsync: async (edgeId: string) => {
      return mutation.mutateAsync({ id: edgeId });
    },
  };
}

export function useUpdateOperationJoinType(_routingRevisionId: string) {
  const queryClient = useQueryClient();
  const mutation = useV1ProductionRoutingOperationsJoinTypePartialUpdate({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getV1ProductionRoutingOperationsListQueryKey(),
        });
      },
    },
  });

  return {
    ...mutation,
    mutateAsync: async ({ operationId, joinType }: { operationId: string; joinType: "AND" | "OR" }) => {
      return mutation.mutateAsync({
        id: operationId,
        data: { upstream_join_type: joinType as any },
      });
    },
  };
}
